export default __webpack_public_path__ + "static/timeline-05-7c0bc5eae3d936d3d006d1f1b349383a.svg";